import ar from './locale/ar';
import bg from './locale/bg';
import ca from './locale/ca';
import cs from './locale/cs';
import da from './locale/da';
import de from './locale/de';
import el from './locale/el';
import en from './locale/en';
import es from './locale/es';
import fa from './locale/fa';
import fi from './locale/fi';
import fr from './locale/fr';
import he from './locale/he';
import hi from './locale/hi';
import hu from './locale/hu';
import id from './locale/id';
import it from './locale/it';
import ja from './locale/ja';
import ko from './locale/ko';
import lv from './locale/lv';
import ml from './locale/ml';
import nl from './locale/nl';
import no from './locale/no';
import pl from './locale/pl';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';
import ro from './locale/ro';
import ru from './locale/ru';
import sk from './locale/sk';
import sr from './locale/sr';
import sv from './locale/sv';
import ta from './locale/ta';
import th from './locale/th';
import tr from './locale/tr';
import uk from './locale/uk';
import vi from './locale/vi';
import zh_CN from './locale/zh_CN';
import zh_TW from './locale/zh_TW';
import is from './locale/is';
import lt from './locale/lt';
import custom from 'custom/dashboard/i18n';

const isPlainObject = value =>
  value && typeof value === 'object' && !Array.isArray(value);

const deepMerge = (target, source) => {
  if (source === undefined || source === null) return target;
  if (!isPlainObject(target) || !isPlainObject(source)) return source;

  const result = { ...target };
  Object.keys(source).forEach(key => {
    const sourceValue = source[key];
    const targetValue = result[key];
    result[key] = isPlainObject(sourceValue)
      ? deepMerge(targetValue || {}, sourceValue)
      : sourceValue;
  });
  return result;
};

const mergeLocale = (baseLocale, customLocale) => {
  return customLocale ? deepMerge(baseLocale, customLocale) : baseLocale;
};

export default {
  ar: mergeLocale(ar, custom?.ar),
  bg: mergeLocale(bg, custom?.bg),
  ca: mergeLocale(ca, custom?.ca),
  cs: mergeLocale(cs, custom?.cs),
  da: mergeLocale(da, custom?.da),
  de: mergeLocale(de, custom?.de),
  el: mergeLocale(el, custom?.el),
  en: mergeLocale(en, custom?.en),
  es: mergeLocale(es, custom?.es),
  fa: mergeLocale(fa, custom?.fa),
  fi: mergeLocale(fi, custom?.fi),
  fr: mergeLocale(fr, custom?.fr),
  he: mergeLocale(he, custom?.he),
  hi: mergeLocale(hi, custom?.hi),
  hu: mergeLocale(hu, custom?.hu),
  id: mergeLocale(id, custom?.id),
  it: mergeLocale(it, custom?.it),
  ja: mergeLocale(ja, custom?.ja),
  ko: mergeLocale(ko, custom?.ko),
  ml: mergeLocale(ml, custom?.ml),
  lv: mergeLocale(lv, custom?.lv),
  nl: mergeLocale(nl, custom?.nl),
  no: mergeLocale(no, custom?.no),
  pl: mergeLocale(pl, custom?.pl),
  pt_BR: mergeLocale(pt_BR, custom?.pt_BR),
  pt: mergeLocale(pt, custom?.pt),
  ro: mergeLocale(ro, custom?.ro),
  ru: mergeLocale(ru, custom?.ru),
  sk: mergeLocale(sk, custom?.sk),
  sr: mergeLocale(sr, custom?.sr),
  sv: mergeLocale(sv, custom?.sv),
  ta: mergeLocale(ta, custom?.ta),
  th: mergeLocale(th, custom?.th),
  tr: mergeLocale(tr, custom?.tr),
  uk: mergeLocale(uk, custom?.uk),
  vi: mergeLocale(vi, custom?.vi),
  zh_CN: mergeLocale(zh_CN, custom?.zh_CN),
  zh_TW: mergeLocale(zh_TW, custom?.zh_TW),
  is: mergeLocale(is, custom?.is),
  lt: mergeLocale(lt, custom?.lt),
};
